import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./SelectUserAndWorkers.css";
import TextInput from "../UIkit/TextInput";
import SearchIcon from "@mui/icons-material/Search";
import DropdownList from "./DoropdownList";
import { toKanaString } from "../../functions/common";
import { getUsersRecords } from "../../functions/users";

const useStyles = makeStyles((theme) => ({
  userSearch: {
    display: "flex",
    alignItems: "center",
  },
  searchButton: {
    marginTop: "20px",
    width: "24px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#757575",
  },
}));

const SelectUser = (props) => {
  const classes = useStyles();
  const {
    username,
    setUsername,
    usernumber,
    setUsernumber,
    userdepnumber,
    setUserdepnumber,
    userdepname,
    setUserdepname,
    setShowSelectUser,
    email,
    setEmail,
    role,
    setRole,
    userid,
    setUserid,
  } = props;
  const [searchWords, setSearchWords] = useState(""); //名称
  const [userList, setUserList] = useState([]);

  const inputSearchWords = useCallback(
    (event) => {
      setSearchWords(event.target.value);
    },
    [setSearchWords]
  );
  //検索ボタンが押されたとき
  const handlesearchButtonClick = async () => {
    //検索処理
    // if(searchWords.length===0){
    //   setUserList([]);
    //   return;
    // }
    try {
      const records = await getUsersRecords(searchWords);
      //console.log(records);
      const names = [];
      records.forEach(function (record) {
        names.push([
          record.usernumber,
          record.username,
          record.departmentid,
          record.departmentname,
          record.email,
          record.role,
          record.uid,
        ]);
      });
      names.sort(function (a, b) {
        if (Number(a[0]) < Number(b[0])) return -1;
        if (Number(a[0]) > Number(b[0])) return 1;
        return 0;
      });

      setUserList(names);
    } catch (error) {
      console.log("Error during search: ", error);
    }
  };
  //決定ボタンが押されたとき
  const handleDecideButtonClick = () => {
    setShowSelectUser(false);
  };
  //キャンセルボタンが押されたとき
  const handleCancelButtonClick = () => {
    setUsername("");
    setUsernumber("");
    setUserdepnumber("");
    setUserdepname("");
    setEmail("");
    setRole("");
    setUserid("");
    setShowSelectUser(false);
  };
  // const names = [
  //   ['03111','林  翔太','101','総務部システム課'],
  //   ['2761','渡部  翔','101','総務部システム課'],
  //   ['1151','長谷川  義浩','101','総務部システム課'],
  //   ['  エラー','見つかりませんでした','101',''],
  //   ['03112','林  翔太','101','総務部システム課'],
  //   ['2762','渡部  翔','101','総務部システム課'],
  //   ['1152','長谷川  義浩','101','総務部システム課'],
  // ];
  return (
    <aside className="modal-container">
      <div className="modal">
        <div className="c-section-container">
          <h2 className="u-text__headline u-text-center">社員検索</h2>
          <div className={classes.userSearch}>
            <TextInput
              fullWidth={true}
              label={"社員番号（前方一致）"}
              multiline={false}
              required={true}
              minRows={1}
              type={"number"}
              onChange={inputSearchWords}
              value={searchWords}
            />
            <button
              className={classes.searchButton}
              onClick={handlesearchButtonClick}
            >
              <SearchIcon />
            </button>
          </div>
          <DropdownList
            userList={userList}
            setUsername={setUsername}
            setUsernumber={setUsernumber}
            setUserdepnumber={setUserdepnumber}
            setUserdepname={setUserdepname}
            setEmail={setEmail}
            setRole={setRole}
            setUserid={setUserid}
          />
          <div className="btn-container">
            <button
              className="btn confirm-btn"
              onClick={handleDecideButtonClick}
            >
              決定
            </button>
            <button className="btn clear-btn" onClick={handleCancelButtonClick}>
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default SelectUser;
